import { TARGET } from '@decodo/utils';

export const currentDashboardSupportedTargets: TARGET[] = [
  TARGET.UNIVERSAL,
  TARGET.GOOGLE,
  TARGET.GOOGLE_SEARCH,
  TARGET.AMAZON_PRODUCT,
  TARGET.AMAZON_PRICING,
  TARGET.YOUTUBE_CHANNEL,
  TARGET.YOUTUBE_SEARCH,
  TARGET.YOUTUBE_SUBTITLES,
  TARGET.TARGET_PRODUCT,
  TARGET.WALMART_PRODUCT,
  TARGET.REDDIT_POST,
  TARGET.GOOGLE_TRAVEL_HOTELS,
  TARGET.GOOGLE_AI_MODE,
  TARGET.GOOGLE_ADS,
  TARGET.GOOGLE_LENS,
  TARGET.BING_SEARCH,
  TARGET.BING,
  TARGET.AMAZON_SEARCH,
  TARGET.AMAZON_SELLERS,
  TARGET.AMAZON_BESTSELLERS,
  TARGET.AMAZON,
  TARGET.TARGET,
  TARGET.TARGET_SEARCH,
  TARGET.WALMART,
  TARGET.WALMART_SEARCH,
  TARGET.YOUTUBE_METADATA,
  TARGET.CHATGPT,
  TARGET.PERPLEXITY,
  TARGET.TIKTOK_POST,
  TARGET.TIKTOK_SHOP_SEARCH,
  TARGET.TIKTOK_SHOP_PRODUCT,
  TARGET.TIKTOK_SHOP_URL,
  TARGET.REDDIT_SUBREDDIT,
  TARGET.REDDIT_USER,
  TARGET.BBB,
  TARGET.AUTOTRADER,
  TARGET.MOBILE,
  TARGET.APPLE_APP_STORE,
  TARGET.AIRBNB,
];
